import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { IAlert } from 'src/app/core/dto';
import { AlertDataService } from 'src/app/main/shared/services/alert-data.service';
import { QuickPanelService } from '../quick-panel.service';
import { LinkHelperComponent } from 'src/app/main/shared/components/link-helper/link-helper.component';
import { Store } from '@ngrx/store';
import { EditRoles, UserHasRoles } from 'src/app/main/shared/services/store/user/selector';

@Component({
  selector: 'app-alert-general',
  templateUrl: './alert-general.component.html',
  styleUrls: ['./alert-general.component.scss'],
  imports: [FlexLayoutModule, MatTooltipModule, MatProgressBarModule, LinkHelperComponent],
})
export class AlertGeneralComponent {
  @Input() alert: IAlert = {} as IAlert;
  private alertService = inject(AlertDataService);
  private router = inject(Router);
  private quickPanelService = inject(QuickPanelService);
  // Acknowledging / closing an alert is an everyday action.
  readonly canAct = inject(Store).selectSignal(UserHasRoles(EditRoles.basic, false));

  postAction(url) {
    if (!this.canAct()) {
      return;
    }
    console.log('1111', url);
    this.alertService.postAlert(url).subscribe();
  }

  getClass(alert: IAlert) {
    if (alert.icon) return 'mdi-' + alert.icon + ' ' + alert.iconColor;
    return '';
  }

  navigateToSref() {
    if (this.alert.sref) {
      this.router.navigateByUrl(this.alert.sref);
      this.quickPanelService.onSetOpen(false);
    }
  }

  get hasLink(): boolean {
    return !!this.alert.sref;
  }
}
